// extracted by mini-css-extract-plugin
export default {"wrap":"documentsView_wrap__b1KWX","header":"documentsView_header__NPa6b"};